import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Box, IconButton, Tooltip, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Swal from "sweetalert2";
import ReusableMuiTable from "../../../components/common/Table/Table";
import { getBlogs } from "../../../api/service/blog.service";
import { showToast } from "../../../components/common/ToastNotification/ToastNotification";
import { deleteBlogById } from "../../../api/service/blog.service";

const BlogListing = () => {
  const navigate = useNavigate();
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchBlogData = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getBlogs({ page, limit: 10 });
 

      setBlogs(res?.blogs || []);
      setTotalPages(res?.lastPage || 1);
    } catch (error) {
      console.error("Failed to fetch blogs:", error);
    } finally {
      setLoading(false);
    }
  }, [page]);


  useEffect(() => {
    fetchBlogData();
  }, [fetchBlogData]);

  const addBlog = () => navigate("/add-blog");

  const handleEdit = useCallback((rowData) => {
    const id = rowData.id || rowData.industryTag;
    navigate(`/update-blog/${id}`);
  }, [navigate]);

  const handleDelete = useCallback((rowData) => {
    const id = rowData.id || rowData._id;
// console.log(id,"Rowid...")
    Swal.fire({
      title: "Are you sure to delete this blog ?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#C39B22",
      cancelButtonColor: "#d32f2f",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {

      let result =    await deleteBlogById(id);
  // console.log(result,"result.....")

          Swal.fire({
            title: "Deleted!",
            text: "Industry has been deleted successfully.",
            icon: "success",
            confirmButtonColor: "#C39B22",
          });


          fetchBlogData();


          showToast.success("Blog deleted successfully");

        } catch (error) {
          console.error("Delete error:", error);
          showToast.error("Failed to delete the blog. Please try again.");

          Swal.fire({
            title: "Error!",
            text: "Something went wrong while deleting.",
            icon: "error",
            confirmButtonColor: "#C39B22",
          });
        }
      }
    });
  }, [fetchBlogData]);




  const truncateText = (text, maxLength = 60) => {
    if (!text) return "";
    return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
  };

  const columns = useMemo(() => [
    {
      name: "category",
      label: "Industry Tag",
      options: {
        customBodyRender: (value) => (
          <Box sx={{
            maxWidth: "150px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            {value}
          </Box>
        ),
      },
    },
    {
      name: "author",
      label: "Author",
      options: {
        customBodyRender: (value) => (
          <Box sx={{
            maxWidth: "120px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }}>
            {value}
          </Box>
        ),
      },
    },
    {
      name: "title",
      label: "Industry Title",
      options: {
        customBodyRender: (value) => (
          <Tooltip title={value} placement="top">
            <Box sx={{
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              cursor: "pointer"
            }}>
              {value}
            </Box>
          </Tooltip>
        ),
      },
    },
    // {
    //   name: "text",
    //   label: "Industry Description",
    //   options: {
    //     customBodyRender: (value) => (
    //       <Tooltip title={value} placement="top">
    //         <Box sx={{
    //           maxWidth: "300px",
    //           overflow: "hidden",
    //           textOverflow: "ellipsis",
    //           whiteSpace: "nowrap",
    //           cursor: "pointer"
    //         }}>
    //           {truncateText(value, 50)}
    //         </Box>
    //       </Tooltip>
    //     ),
    //   },
    // },
    {
      name: "action",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const rowData = blogs[tableMeta.rowIndex];
          return (
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <Tooltip title="Edit">
                <IconButton
                  size="small"
                  sx={{ color: "#000" }}
                  onClick={() => handleEdit(rowData)}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton
                  size="small"
                  sx={{ color: "#d32f2f" }}
                  onClick={() => handleDelete(rowData)}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          );
        },
      },
    },
  ], [blogs, handleEdit, handleDelete]);

  return (
    <>
      <ReusableMuiTable
        title="Blog Listing"
        data={blogs}
        columns={columns}
        loading={loading}
        options={{
          page: page - 1,
          count: totalPages * 10,
          rowsPerPage: 10,
          onChangePage: (newPage) => setPage(newPage + 1),
        }}
        customToolbarRight={
          <Button
            variant="contained"
            onClick={addBlog}
            sx={{
              backgroundColor: "#C39B22",
              textTransform: "none",
              fontWeight: 600,
              height: "36px",
              "&:hover": {
                backgroundColor: "#b18a1f",
              },
            }}
          >
            Add Blog
          </Button>
        }
      />
    </>
  );
};

export default BlogListing;